export default __webpack_public_path__ + "b8a9ea9cc6d64194b91da83c9c6600e5.png";